import { createSelector } from '@reduxjs/toolkit';

import { TrussSolidCalculationDependencies } from '@paragon/layout';

import { RootState } from '../../../store';
import { isLayoutBasedOnRoofContainers } from '../../../store/selectors/layoutModeSelectors';

export const getTrussSolidCalculationDependencies = createSelector(
  isLayoutBasedOnRoofContainers,

  (state: RootState) => state.layout.roofContainers,
  (state: RootState) => state.layout.featurePatternContainers,
  (state: RootState) => state.layout.roofPlanes,
  (state: RootState) => state.layout.ceilingPlanes,
  (state: RootState) => state.layout.ceilingTrays,
  (state: RootState) => state.layout.bearingEnvelopes,

  (
    useRoofContainers,
    roofContainers,
    featurePatternContainers,
    roofPlanes,
    ceilingPlanes,
    ceilingTrays,
    bearingEnvelopes,
  ): TrussSolidCalculationDependencies =>
    useRoofContainers
      ? { roofContainers, featurePatternContainers, bearingEnvelopes }
      : { featurePatternContainers, roofPlanes, ceilingPlanes, ceilingTrays, bearingEnvelopes },
);
